/**
 * eDesk REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { GetEDeskDelegationsResponse } from '../model/getEDeskDelegationsResponse';
// @ts-ignore
import { GetFoldersResponse } from '../model/getFoldersResponse';
// @ts-ignore
import { GetMessageDetailResponse } from '../model/getMessageDetailResponse';
// @ts-ignore
import { GetMessageHeadersResponse } from '../model/getMessageHeadersResponse';
// @ts-ignore
import { GetNewMessagesCountResponse } from '../model/getNewMessagesCountResponse';
// @ts-ignore
import { MoveMessageRequest } from '../model/moveMessageRequest';
// @ts-ignore
import { Recipient } from '../model/recipient';
// @ts-ignore
import { SendDelegationDocumentRequest } from '../model/sendDelegationDocumentRequest';
// @ts-ignore
import { SendDelegationDocumentResponse } from '../model/sendDelegationDocumentResponse';
// @ts-ignore
import { SendMessageRequest } from '../model/sendMessageRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class OVMPOService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Activate an eDesk mailbox for delivery
     * Activates the electronic mailbox (identified by the &#x60;x-edesk-uri&#x60; header) for delivery. The request body is empty. The backend verifies the ID token, verifies the access right to the mailbox, checks that the SAML claim &#x60;Subject.eDeskStatus&#x60; is &#x60;CREATED&#x60; or &#x60;ACTIVE&#x60;, generates the unsigned \&quot;Žiadosť o aktiváciu schránky na doručovanie\&quot; form and sends it to ES ÚPVS via SkTalk. 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateEdesk(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public activateEdesk(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public activateEdesk(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public activateEdesk(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling activateEdesk.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/edesk/activate`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Authorize a message
     * Marks a message as authorized for further processing. The mandatory &#x60;x-audit-log&#x60; JSON header, describing how the action was authorized, is written to the server-side audit log together with the user and timestamp. 
     * @param idMessage IdMessage hodnota získaná z MessageHeader.IdMessage
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param xAuditLog Mandatory JSON payload recording how the delivery receipt was authorized (the method by which the action was performed). The server cannot otherwise determine this, so the whole content is written to the server-side audit log. 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public authorizeMessage(idMessage: number, xEdeskUri: string, xAuditLog: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public authorizeMessage(idMessage: number, xEdeskUri: string, xAuditLog: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public authorizeMessage(idMessage: number, xEdeskUri: string, xAuditLog: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public authorizeMessage(idMessage: number, xEdeskUri: string, xAuditLog: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idMessage === null || idMessage === undefined) {
            throw new Error('Required parameter idMessage was null or undefined when calling authorizeMessage.');
        }
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling authorizeMessage.');
        }
        if (xAuditLog === null || xAuditLog === undefined) {
            throw new Error('Required parameter xAuditLog was null or undefined when calling authorizeMessage.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }
        if (xAuditLog !== undefined && xAuditLog !== null) {
            localVarHeaders = localVarHeaders.set('x-audit-log', String(xAuditLog));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/${this.configuration.encodeParam({name: "idMessage", value: idMessage, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/authorize`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a message
     * Permanently deletes a message from your eDesk mailbox. 
     * @param idMessage IdMessage hodnota získaná z MessageHeader.IdMessage
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteMessage(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteMessage(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteMessage(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteMessage(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idMessage === null || idMessage === undefined) {
            throw new Error('Required parameter idMessage was null or undefined when calling deleteMessage.');
        }
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling deleteMessage.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/${this.configuration.encodeParam({name: "idMessage", value: idMessage, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Download message attachment
     * Downloads a specific attachment from a message as binary content. The &#x60;Content-Type&#x60; header reflects the actual MIME type of the attachment (e.g. &#x60;application/pdf&#x60;, &#x60;application/vnd.etsi.asic-e+zip&#x60;). If the part name is available, it is returned in the &#x60;Content-Disposition&#x60; header. 
     * @param idMessage IdMessage hodnota získaná z MessageHeader.IdMessage
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param partId ID of the part/attachment to download
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadMessagePart(idMessage: number, xEdeskUri: string, partId: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadMessagePart(idMessage: number, xEdeskUri: string, partId: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadMessagePart(idMessage: number, xEdeskUri: string, partId: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadMessagePart(idMessage: number, xEdeskUri: string, partId: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idMessage === null || idMessage === undefined) {
            throw new Error('Required parameter idMessage was null or undefined when calling downloadMessagePart.');
        }
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling downloadMessagePart.');
        }
        if (partId === null || partId === undefined) {
            throw new Error('Required parameter partId was null or undefined when calling downloadMessagePart.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            '*/*',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/message/${this.configuration.encodeParam({name: "idMessage", value: idMessage, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/part/${this.configuration.encodeParam({name: "partId", value: partId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of edesk\&#39;s which user allowed to be delegated by the system
     * Retrieves the list of eDesk accounts that the authenticated user is allowed to delegate access to. This endpoint returns all eDesk instances where the user has been granted delegation permissions, allowing them to act on behalf of those accounts. 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDelegations(xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GetEDeskDelegationsResponse>;
    public getDelegations(xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetEDeskDelegationsResponse>>;
    public getDelegations(xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetEDeskDelegationsResponse>>;
    public getDelegations(xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/edesk/delegation`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GetEDeskDelegationsResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of folders
     * Retrieves the list of folders for the authenticated user. Username is extracted from JWT token. 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getFolders(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GetFoldersResponse>;
    public getFolders(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetFoldersResponse>>;
    public getFolders(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetFoldersResponse>>;
    public getFolders(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling getFolders.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/folder`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GetFoldersResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get message details
     * Returns complete message information including the message body and all attachments. 
     * @param idMessage IdMessage hodnota získaná z MessageHeader.IdMessage
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMessageDetail(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GetMessageDetailResponse>;
    public getMessageDetail(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetMessageDetailResponse>>;
    public getMessageDetail(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetMessageDetailResponse>>;
    public getMessageDetail(idMessage: number, xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idMessage === null || idMessage === undefined) {
            throw new Error('Required parameter idMessage was null or undefined when calling getMessageDetail.');
        }
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling getMessageDetail.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/${this.configuration.encodeParam({name: "idMessage", value: idMessage, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GetMessageDetailResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get message headers for a folder
     * Retrieves paginated message headers from a specific folder. Username is extracted from JWT token. 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param folderId ID of the folder
     * @param count Number of messages to return
     * @param skip Number of messages to skip (offset for pagination)
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMessageHeaders(xEdeskUri: string, folderId: number, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GetMessageHeadersResponse>;
    public getMessageHeaders(xEdeskUri: string, folderId: number, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetMessageHeadersResponse>>;
    public getMessageHeaders(xEdeskUri: string, folderId: number, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetMessageHeadersResponse>>;
    public getMessageHeaders(xEdeskUri: string, folderId: number, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling getMessageHeaders.');
        }
        if (folderId === null || folderId === undefined) {
            throw new Error('Required parameter folderId was null or undefined when calling getMessageHeaders.');
        }
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling getMessageHeaders.');
        }
        if (skip === null || skip === undefined) {
            throw new Error('Required parameter skip was null or undefined when calling getMessageHeaders.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>count, 'count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skip, 'skip');

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/folder/${this.configuration.encodeParam({name: "folderId", value: folderId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/message-header`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GetMessageHeadersResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get count of new messages
     * Returns the number of new messages in your mailbox. Note: UPVS does not track read/unread status, so this counts all messages in the inbox. 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNewMessagesCount(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GetNewMessagesCountResponse>;
    public getNewMessagesCount(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetNewMessagesCountResponse>>;
    public getNewMessagesCount(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetNewMessagesCountResponse>>;
    public getNewMessagesCount(xEdeskUri: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling getNewMessagesCount.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/new-count`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GetNewMessagesCountResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Move a message to another folder
     * Moves a message to the specified target folder. 
     * @param idMessage IdMessage hodnota získaná z MessageHeader.IdMessage
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param moveMessageRequest 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveMessage(idMessage: number, xEdeskUri: string, moveMessageRequest: MoveMessageRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public moveMessage(idMessage: number, xEdeskUri: string, moveMessageRequest: MoveMessageRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public moveMessage(idMessage: number, xEdeskUri: string, moveMessageRequest: MoveMessageRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public moveMessage(idMessage: number, xEdeskUri: string, moveMessageRequest: MoveMessageRequest, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idMessage === null || idMessage === undefined) {
            throw new Error('Required parameter idMessage was null or undefined when calling moveMessage.');
        }
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling moveMessage.');
        }
        if (moveMessageRequest === null || moveMessageRequest === undefined) {
            throw new Error('Required parameter moveMessageRequest was null or undefined when calling moveMessage.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/${this.configuration.encodeParam({name: "idMessage", value: idMessage, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/move`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: moveMessageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of available recipients
     * Returns a list of recipients available for the compose dialog. Optionally filters by a search query. 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param query Optional search term for filtering recipients by name or ICO
     * @param limit Maximum number of results to return
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientListGet(xRequestId?: string, xCorrelationId?: string, query?: string, limit?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Recipient>>;
    public recipientListGet(xRequestId?: string, xCorrelationId?: string, query?: string, limit?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Recipient>>>;
    public recipientListGet(xRequestId?: string, xCorrelationId?: string, query?: string, limit?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Recipient>>>;
    public recipientListGet(xRequestId?: string, xCorrelationId?: string, query?: string, limit?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>query, 'query');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>limit, 'limit');

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipient/list`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Recipient>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Force refresh of recipient cache
     * Triggers a manual reload of the recipient list cache. 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public recipientRefreshPost(xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public recipientRefreshPost(xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public recipientRefreshPost(xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public recipientRefreshPost(xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/recipient/refresh`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Search messages by filter
     * All filter parameters are optional and combined (AND logic). Pagination is controlled via &#x60;count&#x60; and &#x60;skip&#x60;.  **DateTime format** for &#x60;dateDeliveryFrom&#x60; / &#x60;dateDeliveryTo&#x60;: - &#x60;dd.MM.yyyy HH:mm:ss.fff&#x60; - &#x60;dd.MM.yyyy HH:mm:ss&#x60; - &#x60;dd.MM.yyyy&#x60; - &#x60;yyyy-MM-dd HH:mm:ss.fff&#x60; - &#x60;yyyy-MM-dd HH:mm:ss&#x60; 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param count Number of messages to return
     * @param skip Number of messages to skip (offset for pagination)
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param idFolder Filter by folder ID.           
     * @param unread If &#x60;true&#x60;, returns only unread messages. If omitted or &#x60;false&#x60;, returns all messages. 
     * @param correlationId Returns messages with the given CorrelationId.
     * @param senderId Returns messages that contain a MessageContainer with the given sender URI (e.g. &#x60;ico://sk/12345678&#x60;). 
     * @param dateDeliveryFrom Returns messages delivered on or after this date (inclusive). See supported DateTime formats in the endpoint description. 
     * @param dateDeliveryTo Returns messages delivered before this date (exclusive). See supported DateTime formats in the endpoint description. 
     * @param idMessageFrom Returns messages whose &#x60;idMessage&#x60; is greater than the given value. Use &#x60;0&#x60; on the first call when the last downloaded message ID is not yet known. For better performance, avoid combining with &#x60;dateDeliveryFrom&#x60;. 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchMessages(xEdeskUri: string, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, idFolder?: number, unread?: boolean, correlationId?: string, senderId?: string, dateDeliveryFrom?: string, dateDeliveryTo?: string, idMessageFrom?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<GetMessageHeadersResponse>;
    public searchMessages(xEdeskUri: string, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, idFolder?: number, unread?: boolean, correlationId?: string, senderId?: string, dateDeliveryFrom?: string, dateDeliveryTo?: string, idMessageFrom?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<GetMessageHeadersResponse>>;
    public searchMessages(xEdeskUri: string, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, idFolder?: number, unread?: boolean, correlationId?: string, senderId?: string, dateDeliveryFrom?: string, dateDeliveryTo?: string, idMessageFrom?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<GetMessageHeadersResponse>>;
    public searchMessages(xEdeskUri: string, count: number, skip: number, xRequestId?: string, xCorrelationId?: string, idFolder?: number, unread?: boolean, correlationId?: string, senderId?: string, dateDeliveryFrom?: string, dateDeliveryTo?: string, idMessageFrom?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling searchMessages.');
        }
        if (count === null || count === undefined) {
            throw new Error('Required parameter count was null or undefined when calling searchMessages.');
        }
        if (skip === null || skip === undefined) {
            throw new Error('Required parameter skip was null or undefined when calling searchMessages.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>idFolder, 'idFolder');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>unread, 'unread');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>correlationId, 'correlationId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>senderId, 'senderId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dateDeliveryFrom, 'dateDeliveryFrom');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dateDeliveryTo, 'dateDeliveryTo');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>idMessageFrom, 'idMessageFrom');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>count, 'count');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>skip, 'skip');

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/search`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<GetMessageHeadersResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send a signed delegation document to the UPVS eDesk
     * Accepts a KEP-signed delegation form (ASiC-E container) together with the user\&#39;s OIDC ID token. The backend verifies the signature via CEP, extracts the SERIALNUMBER from the signer certificate, parses the form data, finds or creates the user record, and sends the delegation to ES ÚPVS via SkTalk from the Ardaco home eDesk. 
     * @param sendDelegationDocumentRequest 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendDelegationDocument(sendDelegationDocumentRequest: SendDelegationDocumentRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SendDelegationDocumentResponse>;
    public sendDelegationDocument(sendDelegationDocumentRequest: SendDelegationDocumentRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SendDelegationDocumentResponse>>;
    public sendDelegationDocument(sendDelegationDocumentRequest: SendDelegationDocumentRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SendDelegationDocumentResponse>>;
    public sendDelegationDocument(sendDelegationDocumentRequest: SendDelegationDocumentRequest, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (sendDelegationDocumentRequest === null || sendDelegationDocumentRequest === undefined) {
            throw new Error('Required parameter sendDelegationDocumentRequest was null or undefined when calling sendDelegationDocument.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/edesk/delegation/send`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SendDelegationDocumentResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sendDelegationDocumentRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send a message
     * Sends a structured message to a recipient through UPVS. The message must conform to the UPVS message format with headers and containers. 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param sendMessageRequest 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sendMessage(xEdeskUri: string, sendMessageRequest: SendMessageRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public sendMessage(xEdeskUri: string, sendMessageRequest: SendMessageRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public sendMessage(xEdeskUri: string, sendMessageRequest: SendMessageRequest, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public sendMessage(xEdeskUri: string, sendMessageRequest: SendMessageRequest, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling sendMessage.');
        }
        if (sendMessageRequest === null || sendMessageRequest === undefined) {
            throw new Error('Required parameter sendMessageRequest was null or undefined when calling sendMessage.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/message/send`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: sendMessageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set the label (display name) of an eDesk mailbox
     * Updates the local label (display name) of the mailbox identified by the &#x60;x-edesk-uri&#x60; header. The request body is a JSON string with the new label. The backend verifies the ID token, confirms the mailbox belongs to the user, and updates the DB record. If the new label equals the current one, no change is made. The label must not be empty. 
     * @param xEdeskUri Used to identify the specific edesk instance.
     * @param body 
     * @param xRequestId Used for tracing and debugging. If not provided, a random ID is generated.
     * @param xCorrelationId Used to correlate requests across multiple systems. If not provided, null is used.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setEdeskLabel(xEdeskUri: string, body: string, xRequestId?: string, xCorrelationId?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public setEdeskLabel(xEdeskUri: string, body: string, xRequestId?: string, xCorrelationId?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public setEdeskLabel(xEdeskUri: string, body: string, xRequestId?: string, xCorrelationId?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public setEdeskLabel(xEdeskUri: string, body: string, xRequestId?: string, xCorrelationId?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xEdeskUri === null || xEdeskUri === undefined) {
            throw new Error('Required parameter xEdeskUri was null or undefined when calling setEdeskLabel.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setEdeskLabel.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xCorrelationId !== undefined && xCorrelationId !== null) {
            localVarHeaders = localVarHeaders.set('x-correlation-id', String(xCorrelationId));
        }
        if (xEdeskUri !== undefined && xEdeskUri !== null) {
            localVarHeaders = localVarHeaders.set('x-edesk-uri', String(xEdeskUri));
        }

        // authentication (BearerAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('BearerAuth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/edesk/set-label`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: body,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
